import React from 'react';
import type { ReactChildren } from '@fluentui/react-northstar';
import { Page } from './Container.style';
import { useStyles, Container as ClampContainer } from '@archipro-design/aria';
import { ReactComponent as LogoIcon } from '@rocco/icons/svg/archipro-symbol-logo.svg';

interface ProjectContainerProps {
    children: ReactChildren;
    background?: 'white' | 'gray';
}

const ENABLE_FLOATING_LOGO_BACKGROUND = false;
const Container = ({
    children,
    background = 'white',
}: ProjectContainerProps) => {
    const { css } = useStyles();

    return (
        <div
            className={`${css(Page)} relative overflow-x-clip ${background === 'gray' ? 'bg-gray-50' : 'bg-white'}`}
            style={
                ENABLE_FLOATING_LOGO_BACKGROUND
                    ? {
                          backgroundSize: '100% 87.5rem',
                          backgroundRepeat: 'no-repeat',
                          backgroundImage:
                              'linear-gradient(to bottom, #EEEEEE, #FFFFFF)',
                          backgroundPosition: 'center top',
                      }
                    : {}
            }
        >
            {ENABLE_FLOATING_LOGO_BACKGROUND && (
                <div className="pointer-events-none fixed left-1/2 top-10 z-1 hidden md:block">
                    <LogoIcon />
                </div>
            )}
            <ClampContainer
                className="relative z-10"
                style={{ background: 'transparent', touchAction: 'auto' }}
            >
                {children}
            </ClampContainer>
        </div>
    );
};

export default Container;
